import {
  Component, HostBinding, Input, OnChanges, SimpleChanges, ChangeDetectorRef
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as _ from 'lodash';

import { SortingPanelComponent } from 'shared/search/sorting-panel/sorting-panel.component';


@Component({
  moduleId: module.id,
  selector: 'fitments-sorting-panel',
  templateUrl: 'fitments-sorting-panel.component.html',
  styleUrls: ['fitments-sorting-panel.component.scss'],
})
export class FitmentsSortingPanelComponent extends SortingPanelComponent implements OnChanges {

  @HostBinding('style.width')
  @Input() componentWidth: string = '100%';

  @Input() scrollLeft: number = 0;
  @Input() scrollLeftBorder: number = 24; // border after which we need to fix first column
  @Input() stickCheckbox: boolean = false;
  @Input() groupedColumns: Array<any> = [];
  @Input() comingSoonColumns: Array<string>;

  constructor(
    protected sanitizer: DomSanitizer,
    protected ref: ChangeDetectorRef,
  ) {
    super(sanitizer, ref, null);
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    if (changes.componentWidth || changes.scrollLeft || changes.stickCheckbox || changes.groupedColumns || changes.columns) {
      this.detectChanges();
    }
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public detectChanges(): void {
    this.ref.detectChanges();
  }

  public isGroupedCol(column: any): boolean {
    if (!column) {
      return false;
    }
    return _.some(this.groupedColumns, (item: any) => {
      return _.includes(item.attributes, column.column_name);
    });
  }

  public getGroupTitle(column: any): string {
    const col = _.find(this.groupedColumns, (item: any) => {
      return _.includes(item.attributes, column.column_name);
    });
    return _.get(col, 'groupTitle', '');
  }

  public comingSoonTooltipTemplate(columnName: string): string {
    return `<div class='tooltip-black-title'>${columnName}</div>
      <p class='tooltip-black-text'>Ability to add ${columnName} is coming soon</p>`;
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onSortingClick(item: any) {
    if (this.isComingSoonColumn(item.columnName)) {
      return;
    }
    super.onSortingClick(item);
  }

  /*******************************************
  * COMPONENT PROTECTED METHODS
  *******************************************/

  // make first column fixed if it's horizontally scrolled
  protected getFirstColTransform(): string {
    return (this.scrollLeft >= this.scrollLeftBorder) ? `translate3d(${this.scrollLeft}px, 0, 0)` : null;
  }

  protected getMinWidth(item): string {
    return item.maxWidth + 'px';
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private isComingSoonColumn(columnName: string): boolean {
    return _.includes(this.comingSoonColumns, columnName);
  }
}
